/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";

import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { UPDATE_KYC_STATUS } from "../graphql";
import { VApplication } from "../../../application";
import { useUserId } from "../provider";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUpdateKycMethods extends IPluginMethodMap {
  getUpdateKyc(args: any): Promise<any>;
}

export interface UpdateKycProps {
  docIds:string[];
  comments: string;
  kyc_status: string;
}

export class UpdateKycService implements IAgentPlugin {
  readonly methods: IUpdateKycMethods;
  constructor() {
    this.methods = {
      getUpdateKyc: this.getUpdateKyc.bind(this),
    };
  }

  async getUpdateKyc(args: UpdateKycProps) {
    console.log(`kyc data inside mutation`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const { userId } = useUserId();
    try {
      if (client) {
        const res = await client.mutate({
          mutation: UPDATE_KYC_STATUS,
          variables: {
            input: {
                docIds: args?.docIds || [],
              comment: args?.comments ?? null,
              status: args?.kyc_status === "approve" ? "VERIFIED" : "REJECTED",
              vuid: userId,
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          console.log("hi updated")
          return res?.data?.updateKycStatusByIds?.message;
        }
      }
    } catch (err: any) {
      throw err;
    }
  }
}
